const { VITE_APP_PROTOCOL, VITE_APP_ROOT_DOMAIN } = import.meta.env;

function formatDomainString(domain: string) {
  domain = domain.trim().toLowerCase();

  const protocolIndex = domain.indexOf('//');

  if (protocolIndex > -1) {
    domain = domain.slice(protocolIndex + 2);
  }

  const firstForwardSlashIndex = domain.indexOf('/');

  if (firstForwardSlashIndex > -1) {
    domain = domain.slice(0, firstForwardSlashIndex);
  }

  return domain;
}

function formatPathString(path: string) {
  if (typeof path !== 'string') { // TODO: keep this while JS is still in use
    return '';
  }

  path = path
    .trim()
    .replace(/^\//, '')
    .replace(/\/$/, '');

  if (path) {
    path = '/' + path;
  }

  return path;
}

function buildParameterString(parametersObj: Record<string, string>, shouldUrlEncodeParameters: boolean = false) {
  if (!parametersObj || typeof parametersObj !== 'object' || Object.keys(parametersObj).length === 0) { // TODO: keep this while JS is still in use
    return '';
  }

  let urlParameterString = '?';
  let isFirstParameter = true;

  for (const parameterKey in parametersObj) {
    if (!isFirstParameter) {
      urlParameterString += '&';
    }

    const encodedParameterKey = shouldUrlEncodeParameters ? encodeURIComponent(parameterKey) : parameterKey;
    const encodedParameterValue = shouldUrlEncodeParameters ? encodeURIComponent(parametersObj[parameterKey]) : parametersObj[parameterKey];

    urlParameterString += `${encodedParameterKey}=${encodedParameterValue}`;
    isFirstParameter = false;
  }

  if (urlParameterString === '?') {
    return '';
  }

  return urlParameterString;
}

interface BuildUrlStringOptions {
  domain?: string;
  areParametersAlreadyUrlEncoded?: boolean;
  isHttps?: boolean;
  parameters?: Record<string, string>;
}

export function buildUrlString(path: string, options: BuildUrlStringOptions = {}) {
  const { domain, areParametersAlreadyUrlEncoded, isHttps, parameters } = options;

  const protocol = isHttps ? 'https' : VITE_APP_PROTOCOL;
  const shouldUrlEncodeParameters = areParametersAlreadyUrlEncoded !== true;
  const formattedDomain = formatDomainString(domain ?? VITE_APP_ROOT_DOMAIN);
  const formattedPath = formatPathString(path);
  const parameterString = buildParameterString(parameters ?? {}, shouldUrlEncodeParameters);

  return `${protocol}://${formattedDomain}${formattedPath}${parameterString}`;
}
